import { Outlet, useParams } from "react-router-dom";
import { Box } from "@mui/material";
import CustomBackButton from "@/components/custom/custom-back-button";
import CustomTabs from "@/components/custom/custom-tabs";
import { useMerchantId } from "@/hooks/use-merchant-id";
import DetailItem from "./_components/detail-item";
import { useUserById } from "@/hooks/use-user-by-id";
import { formatLabel } from "@/utils/format-label";

const TAB_DEFS = [
  { name: "Profile", path: "profile" },
  { name: "KYC", path: "kyc" },
  { name: "Transactions", path: "transactions" },
  // { name: "Products", path: "products" },
  // { name: "Accounts", path: "accounts" },
  { name: "Teams", path: "teams" },
  { name: "Referees", path: "referees" },
  // { name: "Documents", path: "documents" },
  { name: "Activity", path: "activity" },
];

const CustomerOutlet = () => {
  const { userId } = useParams();
  const { data: merchantId, isLoading: isMerchantLoading } = useMerchantId(userId);
  const { data, isLoading } = useUserById(userId);

  const fullName = `${formatLabel(data?.firstName)} ${formatLabel(data?.surname)}`;

  const tabs = TAB_DEFS.map((tab) => ({
    ...tab,
    path: `/users/customers/${tab.path}/${userId}`,
  }));

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Box sx={{ px: 2, pt: 2, display: "flex", alignItems: "center", flexWrap: "wrap", gap: 2 }}>
        <CustomBackButton />
        <Box sx={{ display: "flex", gap: 1 }}>
          <DetailItem label="Merchant Name" value={fullName} isLoading={isLoading} />
          <DetailItem label="User ID" value={userId} />
          <DetailItem label="Merchant ID" value={merchantId} isLoading={isMerchantLoading} />
        </Box>
      </Box>

      <Box sx={{ px: 2, mt: 2 }}>
        <CustomTabs tabs={tabs} variant="underline" />
      </Box>

      <Box sx={{ p: 2 }}>
        <Outlet context={{ merchantId, isMerchantLoading }} />
      </Box>
    </Box>
  );
};

export default CustomerOutlet;
